import Dictpicker from './Dictpicker';

export default Dictpicker;
